import { Base } from '@studiometa/js-toolkit';

/**
 * Toast component
 */
export default class Header extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Header',
  };

  /**
   * Service scrolled hook
   * @see https://js-toolkit.studiometa.dev/api/methods-hooks-services.html#scrolled
   * @param {object} props Props
   * @param {number} props.y The current vertical scroll position.
   */
  scrolled({ y }) {
    if (y > 120) {
      document.body.classList.add('is-sticky');
      return;
    }

    document.body.classList.remove('is-sticky');
  }
}
